<template>
  <div class="tw-py-4 tw-px-4 tw-bg-true-gray-100 tw-rounded-md">
    <WdsStack direction-column gap-md>
      <slot />
    </WdsStack>
  </div>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
</script>
